// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionWithChildren_section__pF_oK","bgImgContainer":"SectionWithChildren_bgImgContainer__4ZXTA","offsetContainer":"SectionWithChildren_offsetContainer__eIVFD"};